import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowRoundRightIcon } from '@calendly/ui/components/icons'
import { useState } from 'react'

import { ChooseMemberModal } from './choose_member_modal'
import { ChooseMethodModal } from './choose_method_modal'

const enableModalForRescheduling = (event) => {
  const roundRobinWithOnePool = event.showReschedulingModal
  const hasEnabledUserMemberships = event.eventType.memberships.some((membership) => (
    membership.enabled && !membership.isPending
  ))
  return hasEnabledUserMemberships && roundRobinWithOnePool
}

const rescheduleInvitee = (eventUuid, userUuid) => {
  const baseUrl = `/reschedulings/${eventUuid}?&return_to=${window.location.pathname}`
  const url = userUuid ? `${baseUrl}&new_event_user_uuid=${userUuid}` : baseUrl
  window.location.assign(url)
}

export const RescheduleButton = ({ event, sendAnalytics }) => {
  const [step, setStep] = useState(null)

  if (event.eventType.kind !== 'solo') return null

  const { uuid } = event.invitee

  const showChooseMethodModal = step === 'choose_method'
  const showChooseMemberModal = step === 'choose_member'

  const rescheduleWithoutUserUUID = () => {
    setStep(null)
    rescheduleInvitee(uuid, null)
  }

  const rescheduleWithUserUUID = (userUUID) => {
    setStep(null)
    rescheduleInvitee(uuid, userUUID)
  }

  const onClick = () => {
    if (sendAnalytics) sendAnalytics()
    if (enableModalForRescheduling(event)) {
      setStep('choose_method')
    } else {
      rescheduleWithoutUserUUID()
    }
  }

  return (
    <>
      <Button decoration="secondary-outline" size="small" onClick={onClick}>
        <ArrowRoundRightIcon />
        {I18n.t('publisher.action.reschedule')}
      </Button>
      {
        showChooseMethodModal && (
          <ChooseMethodModal
            onRoundRobin={rescheduleWithoutUserUUID}
            onTeamMember={() => setStep('choose_member')}
            onClose={() => setStep(null)}
          />
        )
      }
      {
        showChooseMemberModal && (
          <ChooseMemberModal
            event={event}
            onBack={() => setStep('choose_method')}
            onSelect={rescheduleWithUserUUID}
            onClose={() => setStep(null)}
          />
        )
      }
    </>
  )
}
